import { Injectable } from '@angular/core';
import { HealthModels } from 'models/health.models';
import { TableModels } from 'models/table.models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  projectDirectDebitFileTableRow,
  projectRejectFileTableRow,
} from '../projectors/health.projector';
import { projectPaginatedResult } from '../projectors/table-projectors';
import { HealthAdminApiService } from './api/health/health-admin-api.service';

@Injectable({
  providedIn: 'root',
})
export class HealthAdminService {
  constructor(private api: HealthAdminApiService) {}

  sendDirectDebitFile(
    file: File,
  ): Observable<HealthModels.DirectDebitFileTableRow> {
    return this.api
      .postSendDirectDebitFile(file)
      .pipe(map((res) => projectDirectDebitFileTableRow(res)));
  }

  getDirectDebitFiles(request: TableModels.PaginatedRequest) {
    return this.api
      .getDirectDebitFiles(request)
      .pipe(
        map((res) =>
          projectPaginatedResult(res, projectDirectDebitFileTableRow),
        ),
      );
  }

  getRejectFiles(request: TableModels.PaginatedRequest) {
    return this.api
      .getRejectFiles(request)
      .pipe(
        map((res) => projectPaginatedResult(res, projectRejectFileTableRow)),
      );
  }

  markRejectAsDone(
    rejectId: number,
  ): Observable<HealthModels.RejectFileTableRow> {
    return this.api
      .postMarkRejectAsDone(rejectId)
      .pipe(map((res) => projectRejectFileTableRow(res)));
  }
}
